<template>
  <div
    :class="[$style.container, $style[containerSize]]"
  >
    <ModalHeader
      :handleClose="handleClose"
      :showClose="false"
    />
    <h2
      :class="$style.header"
    >
      Creating your <strong>Implementation Checklist...</strong>
    </h2>
    <SimplifiedOnboardingLoadingAnimation
      key="SimplifiedOnboardingLoadingAnimation"
      :featureList="featureList"
      @animationComplete="handleClose"
    />
  </div>
</template>

<script>
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';

import SimplifiedOnboardingLoadingAnimation from './SimplifiedOnboardingLoadingAnimation.vue';

const onboardingModule = 'OnboardingModule';

const {
  description,
  location,
} = eventProperties;

export default {
  name: 'ImplementationChecklistLoadingModal',

  components: {
    ModalHeader,
    SimplifiedOnboardingLoadingAnimation,
  },

  EventHelper,

  ModalEventBus,

  props: {
    featureList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    containerSize() {
      let containerSize = 'containerSmall';

      if (this.featureList.length >= 4 && this.featureList.length <= 6) {
        containerSize = 'containerMedium';
      } else if (this.featureList.length > 6) {
        containerSize = 'containerLarge';
      }

      return containerSize;
    },
  },

  mounted() {
    this.updateImplementationChecklistDismissed(true);
    this.triggerSegmentEvent();
  },

  methods: {
    ...mapActions(onboardingModule, [
      'setShowChecklistLoading',
      'updateImplementationChecklistDismissed',
    ]),

    handleClose() {
      setTimeout(() => {
        this.setShowChecklistLoading(false);
        this.$options.ModalEventBus.close();
      }, 750);
    },

    triggerSegmentEvent() {
      this.$options.EventHelper.triggerModalViewed({
        [description]: 'The implementation checklist loading/artificial wait modal was viewed.',
        [location]: eventLocations.implementationChecklistLoadingModal,
      });
    },
  },
};
</script>

<style module>

.container {
  font-size: 1.25rem;
  overflow: hidden;
  position: relative;
}

.containerSmall {
  height: 500px;
}

.containerMedium {
  height: 650px;
}

.containerLarge {
  height: 800px;
}

.header {
  font-weight: 300;
  text-align: center;
}

.successContainer {
  display: flex;
  height: 100%;
}

</style>
